function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pr)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M129.185 19.471V29.071C129.185 32.6779 127.976 36.1807 125.75 39.0192C123.525 41.8578 120.412 43.8682 116.909 44.729L101.633 48.484V10.955L114.333 7.83298C116.098 7.39898 117.939 7.37213 119.716 7.75449C121.494 8.13684 123.161 8.9184 124.591 10.04C126.022 11.1616 127.179 12.5938 127.974 14.2284C128.77 15.863 129.183 17.6571 129.183 19.475L129.185 19.471Z",
  fill: "#F9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.185 29.075C129.185 32.6819 127.976 36.1846 125.75 39.0232C123.525 41.8617 120.412 43.8721 116.909 44.7329L101.633 48.4879",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.661 26.132C115.068 26.132 115.398 25.802 115.398 25.395C115.398 24.9879 115.068 24.658 114.661 24.658C114.254 24.658 113.924 24.9879 113.924 25.395C113.924 25.802 114.254 26.132 114.661 26.132Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.976 26.132C126.383 26.132 126.713 25.802 126.713 25.395C126.713 24.9879 126.383 24.658 125.976 24.658C125.569 24.658 125.239 24.9879 125.239 25.395C125.239 25.802 125.569 26.132 125.976 26.132Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.617 30.823V19.475H127.304",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.234 19.475H117.921",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.449 25.292V29.233C102.428 29.233 101.448 28.8274 100.726 28.1054C100.004 27.3835 99.5983 26.4042 99.598 25.383C99.598 25.264 99.603 25.148 99.614 25.032C99.83 22.643 103.449 22.892 103.449 25.292Z",
  fill: "#F9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.449 29.2339C102.428 29.2339 101.448 28.8283 100.726 28.1063C100.004 27.3843 99.5983 26.4051 99.598 25.3839",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.057 34.84C118.579 35.3181 117.93 35.5867 117.254 35.5867C116.578 35.5867 115.929 35.3181 115.451 34.84",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.617 30.837L119.13 31.448",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.243 167.805L69.774 163.566L53.074 229.418L14.744 438.379H66.92L60.843 427.489L134.243 167.805Z",
  fill: "#F9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.632 426.856L145.803 307.956L95.071 317.456L106.85 438.375H150.208L142.632 426.856Z",
  fill: "#F9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.491 169.107L0.000976562 300.761C0.000976562 300.761 75.301 340.394 150.208 318.992L148.56 140.665L63.491 169.107Z",
  fill: "#FA7F58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.559 88.3139L148.631 148.46L63.3311 169.426V102.419C63.3312 90.8737 67.2023 79.6619 74.3254 70.5762C81.4486 61.4904 91.4125 55.0553 102.624 52.2999C108.085 50.9576 113.779 50.8748 119.277 52.0576C124.774 53.2405 129.931 55.6581 134.356 59.1275C138.782 62.5969 142.36 67.0273 144.821 72.0836C147.282 77.1398 148.561 82.6895 148.561 88.3129L148.559 88.3139Z",
  fill: "#AC7FE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.449 24.451C103.449 24.451 107.957 21.6809 108.13 16.6599C108.13 16.6599 119.51 6.45993 128.19 14.6759",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.185 23.3599C129.185 23.3599 138.785 6.61793 119.13 1.42393C99.475 -3.77007 69.64 23.9309 101.524 41.5909",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.8831 29.459C85.8831 29.459 88.3531 38.659 94.3231 40.336",
  stroke: "#EE5998",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.545 32.8989C83.545 32.8989 62.899 47.0869 69.91 66.0439C76.921 85.0009 109.71 85.1319 111.948 71.1089C114.186 57.0859 107.648 49.0089 99.598 47.9959C91.548 46.9829 92.375 41.5899 92.375 41.5899",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M101.918 90.589L106.39 120.455C119.635 122.792 158.273 110.316 158.273 110.316C173.373 97.461 171.502 106.924 171.502 106.924L184.632 106.488H184.772C185.673 106.487 186.551 106.773 187.277 107.305C188.004 107.838 188.542 108.588 188.813 109.447C189.083 110.307 189.072 111.23 188.782 112.082C188.491 112.935 187.936 113.673 187.197 114.188L186.297 114.816L175.15 122.616C148.557 161.228 87.8911 166.942 69.0681 139.933C64.1888 132.87 61.3445 124.603 60.846 116.033C59.454 96.213 69.0681 78.756 69.0681 78.756",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.633 146.171V150.037C119.671 165.837 82.467 168.262 69.073 147.979C63.173 139.041 64.705 132.61 63.396 128.766L63.328 128.566C64.696 132.607 66.6303 136.433 69.073 139.931C82.97 159.872 119.671 161.976 148.633 146.171Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.901 135.398C208.222 144.371 212.201 61.8459 212.201 61.8459L218.631 58.8409",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.856 65.67L163.209 92.665L192.99 55.183",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M286.951 8.04695L272.151 8.26497L203.335 49.42C203.005 49.617 202.718 49.877 202.489 50.1851C202.26 50.4932 202.094 50.8434 202.001 51.2157C201.907 51.588 201.888 51.975 201.944 52.3548C202 52.7345 202.13 53.0996 202.327 53.429L207.909 62.764C208.106 63.0934 208.366 63.3808 208.674 63.6097C208.982 63.8387 209.332 64.0047 209.705 64.0983C210.077 64.1919 210.464 64.2112 210.844 64.1552C211.224 64.0992 211.588 63.969 211.918 63.772L280.734 22.617L287.934 9.67998C288.028 9.51097 288.075 9.32025 288.072 9.12706C288.068 8.93387 288.014 8.745 287.914 8.57945C287.815 8.41391 287.673 8.27755 287.504 8.18407C287.335 8.09059 287.144 8.04329 286.951 8.04695V8.04695Z",
  fill: "#E3D7FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.821 14.0519C285.145 14.0015 284.492 13.7894 283.916 13.4335C283.339 13.0776 282.857 12.5884 282.509 12.007C282.162 11.4257 281.959 10.7692 281.918 10.0931C281.877 9.41693 282 8.74088 282.275 8.12194L287.275 8.04794C287.467 8.04552 287.657 8.09372 287.825 8.18771C287.994 8.2817 288.134 8.41819 288.233 8.58352C288.332 8.74886 288.385 8.93723 288.389 9.12982C288.392 9.3224 288.344 9.51245 288.251 9.68093L285.821 14.0519Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M288.256 9.68091L281.063 22.6169L212.247 63.7719",
  stroke: "#131313",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M192.99 55.1829C192.99 55.1829 203.805 34.5969 224.382 38.4209C224.748 39.8839 223.749 40.9849 222.305 42.0459L213.398 45.3829",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.891 55.4719L218.039 53.3059C212.617 53.0059 209.194 58.4059 212.292 62.3819L213.274 63.6429C213.937 64.429 214.752 65.0735 215.67 65.5383C216.588 66.003 217.589 66.2785 218.615 66.3483C219.642 66.4181 220.672 66.2807 221.644 65.9445C222.616 65.6082 223.51 65.0799 224.274 64.3909L226.457 62.3419C229.816 59.1889 232.008 55.5419 229.263 53.9679",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pr"
}, /*#__PURE__*/React.createElement("rect", {
  width: 288.936,
  height: 438.38,
  fill: "white"
})));

var SvgPencilRama = function SvgPencilRama(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 439,
    viewBox: "0 0 289 439",
    fill: "none",
    className: "hidden md:block absolute top-0 left-0 ml-4 mt-80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencilRama, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PencilRama.0dfe3bb1.svg";
export { ForwardRef as ReactComponent };